import React, { useState } from 'react';
import { IGreenScreenVehicleModel, rage, useObservable } from '~/rage';
import { StyledEntitySelectorContainer } from '../components/EntitySelectorContainer';
import { EntitySelectorFilter } from '../components/EntitySelectorFilter';
import { EntitySelectorTable } from '../components/EntitySelectorTable';
import { StyledPanelContent } from '../components/PanelContent';
import { StyledPanelFooter } from '../components/PanelFooter';
import { StyledPanelHeader } from '../components/PanelHeader';

const EntitySelector: React.FC = () => {
	const vehicleModels = useObservable<IGreenScreenVehicleModel[]>(
		rage.greenScreen.getVehicleModels(),
	);
	const [filterText, setFilterText] = useState('');

	return (
		<StyledEntitySelectorContainer>
			<StyledPanelHeader>Менеджер элементов</StyledPanelHeader>
			<StyledPanelContent>
				<EntitySelectorTable>
					{vehicleModels
						.filter(({ name }) => name.toLowerCase().includes(filterText))
						.map(({ model, name }, index) => {
							return (
								<div
									key={`item#${index}`}
									onClick={() => rage.greenScreen.swapVehicleModel(model)}
								>
									{name}
								</div>
							);
						})}
				</EntitySelectorTable>
			</StyledPanelContent>
			<StyledPanelFooter>
				<EntitySelectorFilter
					onChange={(newValue) => setFilterText(newValue.toLowerCase())}
				>
					Фильтр
				</EntitySelectorFilter>
			</StyledPanelFooter>
		</StyledEntitySelectorContainer>
	);
};

export { EntitySelector };
